import React from 'react';
import { Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import Header from './components/Header';
import Home from './components/Home';
import Collection from './components/Collection';
import About from './components/About';
import Contact from './components/Contact';
import AvailableForSale from './components/AvailableForSale';
import Commission from './components/Commission';
import Admin from './components/Admin';
import AdminOrders from './components/AdminOrders';
import SearchPage from './components/SearchPage';
import Favorites from './components/Favorites';
import GuestArtists from './components/GuestArtists';
import DeviceTestPage from './components/DeviceTestPage';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import SquareProvider from './components/SquareProvider';
import { AuthProvider } from './context/AuthContext';

const AppContainer = styled.div`
  min-height: 100vh;
  padding: 0 20px;
  max-width: 1600px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 0 10px;
  }
`;

const MainContent = styled.main`
  padding-top: 10px;

  @media (max-width: 1100px) {
    padding-top: 10px;
  }

  @media (max-width: 768px) {
    padding-top: 10px;
  }
`;

function App() {
  return (
    <AuthProvider>
      <SquareProvider>
        <AppContainer>
          <Header />
          <MainContent>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/collection/:id" element={<Collection />} />
              <Route path="/available" element={<AvailableForSale />} />
              <Route path="/commission" element={<Commission />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/favorites" element={<Favorites />} />
              <Route path="/guest-artists" element={<GuestArtists />} />
              <Route path="/device-test" element={<DeviceTestPage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              } />
              <Route path="/admin/orders" element={
                <ProtectedRoute>
                  <AdminOrders />
                </ProtectedRoute>
              } />
            </Routes>
          </MainContent>
        </AppContainer>
      </SquareProvider>
    </AuthProvider>
  );
}

export default App;